"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBreakpoints = exports.breakpoints = void 0;
exports.breakpoints = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
};
exports.createBreakpoints = function () {
    return {
        size: exports.breakpoints,
        down: function (breakpoint) { return "@media (max-width: " + exports.breakpoints[breakpoint] + "px)"; },
        up: function (breakpoint) { return "@media (min-width: " + exports.breakpoints[breakpoint] + "px)"; },
    };
};
//# sourceMappingURL=createBreakpoints.js.map